class AddToCalendar {
  memberString = 'Love MoMA events? Enjoy even more as a member. Join today! (http://mo.ma/2qrqv4y)';
  memberStringHtml = 'Love MoMA events? Enjoy even more as a member. <a href="http://mo.ma/2qrqv4y">Join today!</a>';
  disclaimerString = 'Times and dates are subject to change, so be sure to check moma.org prior to your event.';
  disclaimerStringHtml = 'Times and dates are subject to change, so be sure to check <a href="https://www.moma.org">moma.org</a> prior to your event.';

  buttonQuery = '[data-add-to-calendar-button]';
  containerQuery = '[data-add-to-calendar-container]';
  googleCalendarLinkQuery = '[data-add-to-calendar-link=google]';
  icsCalendarLinkQuery = '[data-add-to-calendar-link=ics]';

  constructor(props) {
    this.el = props.el;

    this.hiddenClass = props.hiddenClass ? props.hiddenClass : 'layout/none';
    this.activeClass = props.activeClass ? props.activeClass : 'layout/block';

    this.hiddenButtonClass = props.hiddenButtonClass ? props.hiddenButtonClass : 'layout/none';
    this.activeButtonClass = props.activeButtonClass ? props.activeButtonClass : 'link/focus';

    this.occurrence = {
      title: this.el.getAttribute('data-title'),
      beginDatetime: this.el.getAttribute('data-occurrence-begin-datetime'),
      endDatetime: this.el.getAttribute('data-occurrence-end-datetime'),
      location: this.el.getAttribute('data-occurrence-location'),
      shortLocation: this.el.getAttribute('data-occurrence-short-location'),
      description: this.el.getAttribute('data-occurrence-description'),
      url: this.el.getAttribute('data-occurrence-url'),
    }

    this.initEvents();
  }

  initEvents() {
    this.el.querySelector(this.buttonQuery).addEventListener('click', this.showCalendarMenu.bind(this));
    this.el.querySelector(this.googleCalendarLinkQuery).addEventListener('click', this.setGoogleCalendar.bind(this));
    this.el.querySelector(this.icsCalendarLinkQuery).addEventListener('click', this.setIcsCalendar.bind(this));
  }

  showCalendarMenu(event) {
    event.preventDefault();
    this.toggleCalendarMenu();
  }

  toggleCalendarMenu() {
    this.el.querySelector(this.containerQuery).classList.toggle(this.hiddenClass);
    this.el.querySelector(this.containerQuery).classList.toggle(this.activeClass);

    this.el.querySelector(this.buttonQuery).classList.toggle(this.hiddenButtonClass);
    this.el.querySelector(this.buttonQuery).classList.toggle(this.activeButtonClass);
  }

  setGoogleCalendar() {
    let googleUrl = 'https://www.google.com/calendar/render?';
    googleUrl += 'action=TEMPLATE&';
    googleUrl += 'text=' + this.occurrence.title + '&';
    googleUrl += 'dates=' + this.occurrence.beginDatetime + '/' + this.occurrence.endDatetime + '&';
    googleUrl += 'details=' + this.getDescriptionHtml() + '&';
    googleUrl += 'location=' + this.occurrence.location;

    this.el.querySelector(this.googleCalendarLinkQuery).href = googleUrl;
    this.toggleCalendarMenu();
  }

  setIcsCalendar() {
    this.setIcs(this.el.querySelector(this.icsCalendarLinkQuery));
    this.toggleCalendarMenu();
  }

  urlWithFallback() {
    return this.occurrence.url || (window.location.origin + window.location.pathname)
  }

  setIcs(el) {
    let href = encodeURI(
      'data:text/calendar;charset=utf8,' + [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'BEGIN:VEVENT',
        'URL:' + this.urlWithFallback(),
        'DTSTART:' + this.occurrence.beginDatetime,
        'DTEND:' + this.occurrence.endDatetime,
        'SUMMARY:' + this.occurrence.title,
        'DESCRIPTION:' + this.getDescriptionText(),
        'LOCATION:' + this.occurrence.location,
        'END:VEVENT',
        'END:VCALENDAR'].join('\n')
    );

    el.href = href;
    el.download = this.occurrence.title + '.ics';
  }

  getDescriptionText() {
    return this.getDescription('\\n\\n', this.memberString, this.disclaimerString);
  }

  getDescriptionHtml() {
    return encodeURI(this.getDescription('<br><br>', this.memberStringHtml, this.disclaimerStringHtml));
  }

  getDescription(separator, memberString, disclaimerString) {
    let description = '';
    if (this.occurrence.shortLocation !== '')
      description = 'Location: ' + this.occurrence.shortLocation + separator;

    description += this.occurrence.description + separator + memberString + separator + disclaimerString;
    return description;
  }

}

document.addEventListener("DOMContentLoaded", () => {
  [].forEach.call(document.querySelectorAll('[data-add-to-calendar]'), (el) => {
    new AddToCalendar({
      el: el,
      hiddenClass: 'layout/none',
      activeClass: 'layout/flex:row',
      hiddenButtonClass: 'layout/none',
      activeButtonClass: 'link/focus',
    });
  });
});

